import { Component, Input, OnInit, Output} from '@angular/core';
import { Router } from '@angular/router';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { ParametreAppel } from '../models/svi.model';
import { TagXitiService } from '../services/tagxiti.service';
import { CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { Subject } from 'rxjs';

declare let cordova: any;

@Component({
  selector: 'cnaf-contacter-caf-svi',
  templateUrl: './contactermacafsvi.component.html'
})

export class ContacterMaCafSviComponent implements OnInit {
  @Input() horaire!: string;
  @Input() disponibiliteFileSviVisuel!: boolean
  @Input() etudiant!: boolean;
  @Output() loading = new Subject<string>();
  androidDevice = false;
  parametreAppel!: ParametreAppel;
  sviDispoVersion = false;
  changementBare = new Subject<boolean>();

  constructor(
    private router: Router,
    private cnafContacterMaCafService: CnafContacterMaCafService,
    private readonly tagXitiService: TagXitiService,
    private readonly cnafAtTagService: CnafAtTagService
  ) { }

  ngOnInit(): void {
    let cookieAppVersion = this.cnafContacterMaCafService.getCookieByName('appVersion');
    this.androidDevice = this.cnafContacterMaCafService.getCookieByName('appOs') === "android";
    cookieAppVersion = cookieAppVersion.replace(/\./g, '-');
    // Pour pouvoir comparer les versions, on transforme celle-ci en nombre (exemple 2.2.0 devient 220)
    // si la version est supérieure ou égale à 2.6.1 (261), alors le svi peut etre disponible
    this.sviDispoVersion = (parseInt(cookieAppVersion.split('-').join(''), 10) >= 261);
  }

  appelerCaf() {
    this.loading.next("loading");
  }
}

